import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import QRCode from "qrcode";
import Select from "react-select";
import { State } from "country-state-city";
import moment from "moment";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { authCall } from "../../../services";
import ImageUploads from "../../util/ImageUploads";
import { Loader } from "@googlemaps/js-api-loader";

const locationType = [
  {
    label: "Activity",
    value: "Activity",
    name: "booking",
  },
  {
    label: "Restaurant",
    value: "Restaurant",
    name: "dinning",
  },
  {
    label: "Nightlife",
    value: "Nightlife",
    name: "nightlife",
  },
];

const subscriptionLevel = [
  {
    label: "Gold",
    value: "Gold",
  },
  {
    label: "Silver",
    value: "Silver",
  },
  {
    label: "Bronze",
    value: "Bronze",
  },
];

const iconType = [
  {
    label: "Icon 1",
    value: "Icon 1",
  },
  {
    label: "Icon 2",
    value: "Icon 2",
  },
  {
    label: "Icon 3",
    value: "Icon 3",
  },
];

const YOUR_GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY;

function ScavengerHungLocationAddPopup({
  closeModal,
  modalStatus,
  itemDetails,
}) {
  const inputRef = useRef(null);
  const today = moment().format("YYYY-MM-DD");
  const { current } = useSelector((state) => state.user);
  const [companies, setCompanaies] = useState([]);
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingLatLong, setLoadingLatLong] = useState("");
  const [field, setField] = useState({});

  useEffect(() => {
    setField({
      userId: current.id,
      id: itemDetails?.id || "",
      date: today,
      company: itemDetails?.company || "",
      companyName: itemDetails?.company_name || "",
      address: itemDetails?.address || "",
      zipCode: itemDetails?.zip_code || "",
      city: itemDetails?.city || "",
      state: itemDetails?.state || "",
      latitude: itemDetails?.latitude || "",
      longitude: itemDetails?.longitude || "",
      googlePlaceId: itemDetails?.google_place_id || "",
      startTime: itemDetails?.start_time || "",
      endTime: itemDetails?.end_time || "",
      activeDays: itemDetails?.active_days || {
        Mon: false,
        Tue: false,
        Wed: false,
        Thu: false,
        Fri: false,
        Sat: false,
        Sun: false,
      },
      locationType: itemDetails?.location_type || "Activity",
      offer: itemDetails?.offer || "",
      offerPhoto: "",
      photoSpot: itemDetails?.photo_spot === "1" || false,
      adult: itemDetails?.adult === "1" || false,
      radio: itemDetails?.is_radio === "1" || false,
      iconType: itemDetails?.icon_type || "",
      subscriptionLevel: itemDetails?.subscription_level || "",
      subscribeButton: "",
      isItemPhotoUploaded: false,
      keyFacts: itemDetails?.key_facts || "",
      radioPrize: itemDetails?.radio_prize || "",
    });
  }, [itemDetails]);

  const getCompanies = async (type) => {
    const resp = await authCall("getSearchList", {
      type: type,
    });
    if (resp?.type === "success") {
      const company = resp?.payload?.details?.map((c) => ({
        ...c,
        value: c.value,
        label: c.label,
      }));
      setCompanaies([
        ...company,
        {
          value: "Other",
          label: "Other",
        },
      ]);
    }
  };

  useEffect(() => {
    getCompanies("booking");
  }, []);

  useEffect(() => {
    const data = State.getStatesOfCountry("AU");
    const options = data.map((s) => ({
      value: s.isoCode,
      label: s.name,
    }));
    setStates(options);
  }, []);

  const handleUpdateLatLong = async (id, address, state, city, zip) => {
    setLoadingLatLong(`load${id}`);
    const resp = await authCall("getAddressLatLong", {
      streetName: address,
      zipCode: zip,
      city: city,
      state: state,
    });
    if (resp.type === "success") {
      setLoadingLatLong("");
      setField({
        ...field,
        latitude: resp?.payload?.Latitude,
        longitude: resp?.payload?.Longitude,
      });
    } else {
      setLoadingLatLong("");
    }
  };

  const getItemPhoto = () => (img) => {
    setField({ ...field, offerPhoto: img, isItemPhotoUploaded: true });
  };

  const handleSubmit = async (item) => {
    toast.dismiss();
    setLoading(true);
    const url = "http://localhost:3000/admin/scavenger-hunt-locaions";
    field.offerPhoto = field.isItemPhotoUploaded ? item.offerPhoto : null;
    field.qrImage = await QRCode.toDataURL(url); // Generate QR code as base64 image
    const resp = await authCall("createScavengerHuntLocaions", field);
    if (resp?.type === "success") {
      setLoading(false);
      toast.success(resp?.message);
      reset();
      closeModal();
    } else {
      setLoading(false);
      toast.error(resp?.message);
    }
  };

  const handleChangeCompany = (item) => {
    setField({
      ...field,
      company: item?.value,
      address: item?.address || "",
      city: item?.city || "",
      state: item?.state || "",
      zipCode: item?.zip || "",
      latitude: item?.latitude || "",
      longitude: item?.longitude || "",
      googlePlaceId: item?.google_place_id || "",
    });
  };

  const reset = () => {
    const initialFieldState = {
      userId: current.id,
      date: today,
      company: "",
      companyName: "",
      address: "",
      zipCode: "",
      city: "",
      state: "",
      latitude: "",
      longitude: "",
      googlePlaceId: "",
      startTime: "",
      endTime: "",
      activeDays: {
        Mon: false,
        Tue: false,
        Wed: false,
        Thu: false,
        Fri: false,
        Sat: false,
        Sun: false,
      },
      locationType: "Activity",
      offer: "",
      offerPhoto: "",
      photoSpot: false,
      adult: false,
      radio: false,
      iconType: "",
      subscriptionLevel: "",
      subscribeButton: "",
      isItemPhotoUploaded: false,
      keyFacts: "",
      radioPrize: "",
    };
    setField(initialFieldState);
  };

  const autocompleteRef = useRef(null);

  const [details, setDetails] = useState({
    city: "",
    state: "",
    country: "",
    postalCode: "",
    lat: "",
    lng: "",
    formattedAddress: "",
  });

  useEffect(() => {
    if (!autocompleteRef.current) return;

    const handlePlaceChange = async () => {
      const place = await autocompleteRef.current.getPlace();
      console.log("Raw place object:", place); // 👀 check full data here

      if (!place) return;

      let city = "";
      let state = "";
      let country = "";
      let postalCode = "";

      if (place.addressComponents) {
        place.addressComponents.forEach((component) => {
          if (component.types.includes("locality")) city = component.longText;
          if (component.types.includes("administrative_area_level_1"))
            state = component.longText;
          if (component.types.includes("country")) country = component.longText;
          if (component.types.includes("postal_code"))
            postalCode = component.longText;
        });
      }

      setDetails({
        city,
        state,
        country,
        postalCode,
        lat: place.location?.lat ?? "",
        lng: place.location?.lng ?? "",
        formattedAddress: place.formattedAddress ?? "",
      });
    };

    // ✅ attach Google Maps event listener
    autocompleteRef.current.addEventListener(
      "gmp-placechange",
      handlePlaceChange
    );

    return () => {
      if (autocompleteRef.current) {
        autocompleteRef.current.removeEventListener(
          "gmp-placechange",
          handlePlaceChange
        );
      }
    };
  }, []);
  return (
    <>
      {console.log("details", details)}
      <Modal
        show={modalStatus}
        centered
        onHide={closeModal}
        backdrop="static"
        keyboard={false}
        dialogClassName="custom-modal"
        size="xl"
        // fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">
            Add Scavenger Hunt Locations:
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="dashboard-page">
          <div className="btn-wrapper d-flex flex-column mx-auto py-2 py-lg-4">
            <div>
              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                {/* LOCATION TYPE */}
                <div className="col-2">
                  <label
                    htmlFor="RestaurantPhone"
                    className="fs-md-16 mb-1 text-custom-primary"
                    style={{ fontWeight: 700 }}
                  >
                    Location Type
                  </label>
                  <Select
                    className="text-body mt-1"
                    placeholder="Select"
                    value={{
                      label: field?.locationType,
                      value: field?.locationType,
                    }}
                    onChange={(e) => {
                      setField({
                        ...field,
                        locationType: e?.value,
                        company: null,
                        address: "",
                        city: "",
                        state: "",
                        zipCode: "",
                        latitude: "",
                        longitude: "",
                        googlePlaceId: "",
                      });
                      getCompanies(e?.name);
                    }}
                    options={locationType}
                  />
                </div>

                {/* COMPANY */}
                <div className="col-3">
                  <label
                    htmlFor="RestaurantPhone"
                    className="fs-md-16 mb-1 text-custom-primary"
                    style={{ fontWeight: 700 }}
                  >
                    Company
                  </label>
                  <Select
                    className="text-body mt-1"
                    placeholder="Select"
                    value={{
                      label: field?.company,
                      value: field?.company,
                    }}
                    onChange={handleChangeCompany}
                    options={companies}
                  />
                </div>

                {field?.company === "Other" && (
                  <div className="col-3">
                    <label
                      htmlFor="RestaurantPhone"
                      className="fs-md-16 mb-2 text-custom-primary"
                      style={{ fontWeight: 700 }}
                    >
                      Enter Company Name
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      value={field.companyName}
                      name="companyName"
                      onChange={(e) =>
                        setField({ ...field, companyName: e.target.value })
                      }
                    />
                  </div>
                )}

                {/* ADDRESS */}
                <div
                  className={`${
                    field?.company === "Other" ? "col-4" : "col-3"
                  }`}
                >
                  <label
                    htmlFor="RestaurantPhone"
                    className="fs-md-16 mb-2 text-custom-primary"
                    style={{ fontWeight: 700 }}
                  >
                    Address
                  </label>
                  {field?.company !== "Other" && (
                    <input
                      disabled
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      value={field?.address}
                      name="address"
                      onChange={(e) =>
                        setField({ ...field, address: e.target.value })
                      }
                    />
                  )}
                  {field?.company === "Other" && (
                    <gmp-place-autocomplete
                      ref={autocompleteRef}
                      placeholder="Enter an address"
                      fields="formattedAddress,addressComponents,location"
                      style={{
                        width: "100%",
                        display: "block",
                        height: 40,
                        borderRadius: 5,
                      }}
                    ></gmp-place-autocomplete>
                  )}
                </div>
                {field?.company !== "Other" && (
                  <>
                    <div className="col-2">
                      <label
                        htmlFor="RestaurantPhone"
                        className="fs-md-16 mb-2 text-custom-primary"
                        style={{ fontWeight: 700 }}
                      >
                        Latitude
                      </label>
                      <input
                        disabled
                        type="text"
                        className="form-control"
                        autoComplete="off"
                        value={field?.latitude}
                        name="latitude"
                        onChange={(e) =>
                          setField({ ...field, latitude: e.target.value })
                        }
                      />
                    </div>
                    <div className="col-2">
                      <label
                        htmlFor="RestaurantPhone"
                        className="fs-md-16 mb-2 text-custom-primary"
                        style={{ fontWeight: 700 }}
                      >
                        Longitude
                      </label>
                      <input
                        disabled
                        type="text"
                        className="form-control"
                        autoComplete="off"
                        value={field?.longitude}
                        name="longitude"
                        onChange={(e) =>
                          setField({ ...field, longitude: e.target.value })
                        }
                      />
                    </div>
                  </>
                )}
              </div>

              {/* city */}
              {field?.company === "Other" && (
                <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                  <div className="col-2">
                    <label
                      htmlFor="RestaurantPhone"
                      className="fs-md-16 mb-2 text-custom-primary"
                      style={{ fontWeight: 700 }}
                    >
                      City
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      value={field.city}
                      name="city"
                      onChange={(e) =>
                        setField({ ...field, city: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-3">
                    <label
                      htmlFor="RestaurantPhone"
                      className="fs-md-16 mb-1 text-custom-primary"
                      style={{ fontWeight: 700 }}
                    >
                      State
                    </label>
                    <Select
                      className="text-body mt-1"
                      // styles={customStyles}
                      placeholder="Select"
                      value={{
                        label: field?.state,
                        value: field?.state,
                      }}
                      onChange={(e) => setField({ ...field, state: e.label })}
                      options={states}
                    />
                  </div>
                  <div className="col-3">
                    <label
                      htmlFor="RestaurantPhone"
                      className="fs-md-16 mb-2 text-custom-primary"
                      style={{ fontWeight: 700 }}
                    >
                      Zip Code
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      value={field.zipCode}
                      name="zipCode"
                      onChange={(e) =>
                        setField({ ...field, zipCode: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-2">
                    <label
                      htmlFor="RestaurantPhone"
                      className="fs-md-16 mb-2 text-custom-primary"
                      style={{ fontWeight: 700 }}
                    >
                      Latitude
                    </label>
                    <input
                      disabled
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      value={field.latitude}
                    />
                  </div>
                  <div className="col-2">
                    <label
                      htmlFor="RestaurantPhone"
                      className="fs-md-16 mb-2 text-custom-primary"
                      style={{ fontWeight: 700 }}
                    >
                      Longitude
                    </label>
                    <input
                      disabled
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      value={field.longitude}
                    />
                  </div>
                  <div className="form-group text-end">
                    <Button
                      className="btn btn-custom btn-custom-sm fs-16 mt-4"
                      onClick={() =>
                        handleUpdateLatLong(
                          field.address,
                          field.state,
                          field.city,
                          field.zipCode
                        )
                      }
                      disabled={loadingLatLong || false}
                    >
                      {loadingLatLong ? "Loading..." : "Update Lat & Long"}
                    </Button>
                  </div>
                </div>
              )}

              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                <div className="col-8">
                  <label
                    htmlFor="RestaurantPhone"
                    className="fs-md-16 mb-1 text-custom-primary"
                    style={{ fontWeight: 700 }}
                  >
                    Active Days
                  </label>
                  <div className="form-group d-flex align-items-center gap-4 flex-wrap">
                    {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(
                      (day, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center gap-2"
                        >
                          <input
                            type="checkbox"
                            className="mt-2"
                            name={`day_${index}`}
                            id={`day_${index}`}
                            checked={field?.activeDays?.[day] || false}
                            onChange={(e) =>
                              setField({
                                ...field,
                                activeDays: {
                                  ...field.activeDays,
                                  [day]: e.target.checked,
                                },
                              })
                            }
                          />
                          <label
                            className="m-0 fs-md-16 text-custom-primary"
                            htmlFor={`day_${index}`}
                          >
                            {day}
                          </label>
                        </div>
                      )
                    )}
                  </div>
                </div>
                <div className="col-2">
                  <label
                    htmlFor="RestaurantPhone"
                    className="fs-md-16 mb-2 text-custom-primary"
                    style={{ fontWeight: 700 }}
                  >
                    Start Time
                  </label>
                  <input
                    required
                    type="time"
                    className="form-control"
                    autoComplete="off"
                    value={field?.startTime}
                    name="startTime"
                    onChange={(e) =>
                      setField({ ...field, startTime: e.target.value })
                    }
                  />
                </div>
                <div className="col-2">
                  <label
                    htmlFor="RestaurantPhone"
                    className="fs-md-16 mb-2 text-custom-primary"
                    style={{ fontWeight: 700 }}
                  >
                    End Time
                  </label>
                  <input
                    required
                    type="time"
                    className="form-control"
                    autoComplete="off"
                    value={field?.endTime}
                    name="endTime"
                    onChange={(e) =>
                      setField({ ...field, endTime: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                <div className="col-4 d-flex align-items-center">
                  <div className="d-flex align-items-center gap-2 m-0">
                    <input
                      type="checkbox"
                      name="photoSpot"
                      id="photoSpot"
                      checked={field?.photoSpot}
                      onChange={(e) =>
                        setField({ ...field, photoSpot: e.target.checked })
                      }
                    />
                    <label
                      className="form-check-label fs-md-16 text-custom-primary"
                      htmlFor="photoSpot"
                    >
                      Photo Spot
                    </label>
                  </div>

                  <div className="form-check d-flex align-items-center gap-2 m-0">
                    <input
                      type="checkbox"
                      name="adult"
                      id="adult"
                      checked={field?.adult}
                      onChange={(e) =>
                        setField({ ...field, adult: e.target.checked })
                      }
                    />
                    <label
                      className="form-check-label fs-md-16 text-custom-primary"
                      htmlFor="adult"
                    >
                      Adult
                    </label>
                  </div>

                  <div className="form-check d-flex align-items-center gap-2 m-0">
                    <input
                      type="checkbox"
                      name="radio"
                      id="radio"
                      checked={field?.radio}
                      onChange={(e) =>
                        setField({ ...field, radio: e.target.checked ? 1 : 0 })
                      }
                    />
                    <label
                      className="form-check-label fs-md-16 text-custom-primary"
                      htmlFor="radio"
                    >
                      Radio
                    </label>
                  </div>
                </div>

                {/* RADIO PRIZE */}
                {field?.radio === 1 && (
                  <div className="col-4">
                    <label
                      htmlFor="RestaurantPhone"
                      className="fs-md-16 mb-2 text-custom-primary"
                      style={{ fontWeight: 700 }}
                    >
                      Radio Prize
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      value={field?.radioPrize}
                      name="radioPrize"
                      onChange={(e) =>
                        setField({ ...field, radioPrize: e.target.value })
                      }
                    />
                  </div>
                )}

                <div className={`${field?.radio === 1 ? "col-2" : "col-4"}`}>
                  <label
                    htmlFor="RestaurantPhone"
                    className="fs-md-16 mb-1 text-custom-primary"
                    style={{ fontWeight: 700 }}
                  >
                    Icon Type
                  </label>
                  <Select
                    className="text-body mt-1"
                    placeholder="Select"
                    value={{
                      label: field?.iconType,
                      value: field?.iconType,
                    }}
                    onChange={(e) => setField({ ...field, iconType: e?.value })}
                    options={iconType}
                  />
                </div>

                <div className={`${field?.radio === 1 ? "col-2" : "col-4"}`}>
                  <label
                    htmlFor="RestaurantPhone"
                    className="fs-md-16 mb-1 text-custom-primary"
                    style={{ fontWeight: 700, zIndex: 0 }}
                  >
                    Subscription Level
                  </label>
                  <Select
                    className="text-body mt-1"
                    placeholder="Select"
                    value={{
                      label: field?.subscriptionLevel,
                      value: field?.subscriptionLevel,
                    }}
                    onChange={(e) =>
                      setField({ ...field, subscriptionLevel: e?.value })
                    }
                    options={subscriptionLevel}
                  />
                </div>
              </div>

              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                {/* KEY FACTORS */}
                <div className="col-4">
                  <label
                    htmlFor="RestaurantPhone"
                    className="fs-md-16 mb-1 text-custom-primary"
                    style={{ fontWeight: 700 }}
                  >
                    Key Facts
                  </label>
                  <textarea
                    rows={3}
                    className="form-control"
                    autoComplete="off"
                    value={field?.keyFacts}
                    name="keyFacts"
                    onChange={(e) =>
                      setField({ ...field, keyFacts: e.target.value })
                    }
                  />
                </div>

                {/* OFFER */}
                <div className="col-4">
                  <label
                    htmlFor="RestaurantPhone"
                    className="fs-md-16 mb-2 text-custom-primary"
                    style={{ fontWeight: 700 }}
                  >
                    Offer
                  </label>
                  <input
                    required
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    value={field?.offer}
                    name="offer"
                    onChange={(e) =>
                      setField({ ...field, offer: e.target.value })
                    }
                  />
                </div>

                {/* OFFER PHOTO */}
                <div className="col-4">
                  <label
                    htmlFor="RestaurantPhone"
                    className="fs-md-16 mb-2 text-custom-primary"
                    style={{ fontWeight: 700 }}
                  >
                    Offer Photo
                  </label>
                  <ImageUploads
                    getImage={getItemPhoto()}
                    uploadedImage={field?.offerPhoto || ""}
                    aspectRation={3 / 2}
                  />
                </div>
              </div>

              <div className="row gx-3 d-flex flex-wrap align-items-center mt-4">
                <div className="col-12 text-center">
                  <button
                    type="button"
                    style={{
                      height: 40,
                      zIndex: 0,
                    }}
                    className="btn btn-custom btn-custom-sm fs-16"
                    onClick={() => handleSubmit(field)}
                    disabled={loading || false}
                  >
                    {loading ? "Loading..." : field?.id ? "Update" : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ScavengerHungLocationAddPopup;
